"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerHostedLiveStreamSchema = void 0;
exports.PartnerHostedLiveStreamSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/partner-hosted-live-stream.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "PartnerHostedLiveStream",
    "description": "A live stream that is hosted on a partner's platform. This will be used to show the partner's logo and a call to action to watch the stream on the partner's platform",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:partner-hosted-live-stream"
            ]
        },
        "targetCountryCode": {
            "type": "string",
            "description": "The country code where the partner has exclusive streaming rights for the live stream"
        },
        "streamingPartner": {
            "description": "The partner profile that is streaming the content. This will be used to show the partner's logo",
            "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
        },
        "postStreamExclusiveTimespan": {
            "$ref": "https://www.redbull.com/schemas/attributes/duration.schema.json",
            "description": "The duration, in ISO 8601 format, for which the partner retains exclusive rights to the stream after it ends. After this period, the stream can be viewed on our owned platforms"
        },
        "callToAction": {
            "$ref": "https://www.redbull.com/schemas/attributes/call-to-action.schema.json",
            "description": "The call to action to watch the stream on the partner's platform"
        }
    },
    "required": [
        "type",
        "targetCountryCode",
        "streamingPartner"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1ob3N0ZWQtbGl2ZS1zdHJlYW0uc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL21vZHVsZXMvYXR0cmlidXRlcy9wYXJ0bmVyLWhvc3RlZC1saXZlLXN0cmVhbS5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw2QkFBNkIsR0FBRztJQUMzQyxLQUFLLEVBQUUsbUZBQW1GO0lBQzFGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHlCQUF5QjtJQUNsQyxhQUFhLEVBQUUsdUtBQXVLO0lBQ3RMLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLHNCQUFzQixFQUFFLEtBQUs7SUFDN0IsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFLFFBQVE7WUFDaEIsTUFBTSxFQUFFO2dCQUNOLHVDQUF1QzthQUN4QztTQUNGO1FBQ0QsbUJBQW1CLEVBQUU7WUFDbkIsTUFBTSxFQUFFLFFBQVE7WUFDaEIsYUFBYSxFQUFFLHVGQUF1RjtTQUN2RztRQUNELGtCQUFrQixFQUFFO1lBQ2xCLGFBQWEsRUFBRSxpR0FBaUc7WUFDaEgsTUFBTSxFQUFFLGdGQUFnRjtTQUN6RjtRQUNELDZCQUE2QixFQUFFO1lBQzdCLE1BQU0sRUFBRSxpRUFBaUU7WUFDekUsYUFBYSxFQUFFLGtMQUFrTDtTQUNsTTtRQUNELGNBQWMsRUFBRTtZQUNkLE1BQU0sRUFBRSx1RUFBdUU7WUFDL0UsYUFBYSxFQUFFLGtFQUFrRTtTQUNsRjtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLG1CQUFtQjtRQUNuQixrQkFBa0I7S0FDbkI7Q0FDRixDQUFBIn0=